var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoFolder = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_Folder",
    d: "M20.167,44.466H10.731L9.032,42.8a.462.462,0,0,0-.324-.132H1.833A1.819,1.819,0,0,0,0,44.466v14.4a1.819,1.819,0,0,0,1.833,1.8H20.167A1.819,1.819,0,0,0,22,58.866v-12.6A1.819,1.819,0,0,0,20.167,44.466Z",
    transform: "translate(0 -42.666)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoFolder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_folder.63e116afea5726f2f9392818b45b929b.svg";